import React, { useEffect, useState } from 'react';
import { Grid } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';

import Countries from './components/Countries';
import HideNavs from './components/Navs';
import HideCategories from './HideCategories';
import HideServices from './HideServices';

import { servicesCountriesList } from '../../../services/endpoints/services';

const routes = [
  {
    name: 'Category',
    path: '/services/hide',
    exact: true,
    component: HideCategories,
  },
  {
    name: 'Service',
    path: '/services/hide/service',
    component: HideServices,
  },
];

const HideLayout = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);

  const getCounties = async () => {
    setIsLoading(true);
    try {
      const response = await servicesCountriesList();
      if (response.success) {
        setCountries(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCounties();
  }, []);

  return (
    <Grid fluid={false}>
      <Countries countries={countries} loading={isLoading} />
      <HideNavs />

      <Switch>
        {routes?.map((route) => (
          <Route key={route.name} exact={route.exact} path={route.path}>
            <route.component />
          </Route>
        ))}
      </Switch>
    </Grid>
  );
};

export default HideLayout;
